import { Model } from '@/models/Model';
import { icon } from '@/support/Icon';
export class File extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'File';
        this.$endpoint = '/files';
        this.$fillable = ['value'];
    }
    subject(subject) {
        this.$endpoint = '/subjects/' + subject.id + '/relationships/files';
        return this;
    }
    group(group) {
        this.$endpoint = '/groups/' + group.id + '/relationships/files';
        return this;
    }
    setEndpoint(endpoint) {
        this.$endpoint = endpoint;
        return this;
    }
    setMimeTypeAttribute(value) {
        if (value.includes('image/') && this.links !== undefined) {
            this.thumbnail = this.links.download;
            return this;
        }
        const mimeType = this.mime_type || '';
        this.thumbnail = icon(mimeType);
        return this;
    }
}
